<script lang="ts" setup>
import { type Format } from '#root/global.type';
import { computed, type PropType } from 'vue';
import DecorativeTag from '../DecorativeTag/DecorativeTag.vue';
import { FORMAT_OPTIONS } from './constants/formatTagOptions.constant';
import type { FormatTagSizeType } from './types/formatTagSize.type';

const props = defineProps({
  type: { type: String as PropType<Format>, required: true },
  size: { type: String as PropType<FormatTagSizeType>, default: 'M' }
});
const format = computed(() => FORMAT_OPTIONS[props.type]);
</script>

<template>
  <DecorativeTag :size="size" :color="format.color">{{ format.name }}</DecorativeTag>
</template>
